import { useContext } from 'react'
import { DonsModalContext } from '@/context/donsModalStore'

// Permet à n'importe quel composant (Header, DonsSection, futurs boutons "Donner"…)
// d'ouvrir la modale des offrandes sans prop-drilling.
export function useDonsModal() {
  const ctx = useContext(DonsModalContext)
  if (!ctx) throw new Error('useDonsModal doit être utilisé sous DonsModalProvider')
  return ctx
}
